module.exports = __webpack_public_path__ + "static/media/1.09c9d161.jpg";